/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Редактирование досыла
 */
export interface AddFileSendingUpdateRequest {
  /** Номер документа ВК, в рамках которого создан досыл */
  documentRefNumber?: string;

  /**
   * Дата создания документа ВК, в рамках которого создан досыл
   * @format date-time
   */
  documentRefDate?: string;

  /** Список вложений */
  attachments?: AttachmentIdRequest[];

  /** Список идентификаторов валютных договоров */
  documentRefContractIds?: string[];
}

/**
 * Информация о вложении
 */
export interface AttachmentIdRequest {
  /**
   * Идентификатор вложения
   * @format uuid
   */
  id?: string;

  /** Категория вложения */
  category?: string;
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Данные сохраненного документа
 */
export interface DocumentSaveResponse {
  /** @format uuid */
  documentId: string;
}

/**
 * Информация о вложении
 */
export interface AttachmentUploadResponse {
  /** Имя файла */
  fileName?: string;

  /** Размер файла */
  size?: string;

  /**
   * Дата заливки файла
   * @format date-time
   */
  createDate?: string;

  /** Хеш-сумма файла */
  hash?: string;

  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор файла
   * @format uuid
   */
  extId?: string;

  /** Состояние сохранения файла */
  ready?: boolean;

  /** Код ошибки сохранения файла */
  errorCode?: string;

  /** Описание ошибки при сохранении файла */
  errorDescription?: string;

  /** Категория файла */
  category?: string;

  /**
   * Идентификатор клиента
   * @format uuid
   */
  clientId?: string;
}

/**
 * Информация о подписанном документе
 */
export interface DocumentSendResponse {
  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Вид документа ВК */
  type?: string;

  /** Номер документа */
  number?: string;

  /** Статус документа */
  state?: string;
}

/**
 * Информация о вложении
 */
export interface AttachmentRequest {
  /** Имя файла */
  fileName?: string;

  /** Содержимое файла с кодировкой в формате base64 */
  encodedString?: string;

  /** Категория файла */
  category?: string;
}

/**
 * Создание досыла
 */
export interface AddFileSendingCreateRequest {
  /** Номер документа ВК, в рамках которого создан досыл */
  documentRefNumber?: string;

  /**
   * Дата создания документа ВК, в рамках которого создан досыл
   * @format date-time
   */
  documentRefDate?: string;

  /** Список вложений */
  attachments?: AttachmentIdRequest[];

  /** Список идентификаторов валютных договоров */
  documentRefContractIds?: string[];
}

/**
 * Список привилегий документа
 */
export interface PermissionListResponse {
  /** Тип документа */
  entityStrId?: string;

  /** Список разрешений */
  permissions?: PermissionResponse[];
}

/**
 * Привилегия
 */
export interface PermissionResponse {
  /** Название действия */
  name?: string;

  /** Описание действия */
  desc?: string;

  /** Признак доступности действия */
  isAvailable?: boolean;
}

/**
 * Получение ккб документа
 */
export interface AddFileSendingCcb {
  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата создания документа
   * @format date-time
   */
  createDate?: string;

  /** Валютный документ, к которому создан досыл */
  documentRef?: DocumentRef;

  /** Вложения к документу */
  attachments?: AttachmentCcb[];

  /** Причина отказа по договору */
  reject?: RejectCcb;

  /**
   * Дата представления резидентом документа
   * @format date-time
   */
  receiveDate?: string;

  /**
   * Дата завершения обработки документа
   * @format date-time
   */
  executeDate?: string;

  /** ФИО сотрудника обрабатывающего документ */
  employeeName?: string;
}

/**
 * Информация о вложении
 */
export interface AttachmentCcb {
  /** Имя файла */
  fileName?: string;

  /** Размер файла */
  size?: string;

  /**
   * Дата заливки файла
   * @format date-time
   */
  createDate?: string;

  /** Хеш-сумма файла */
  hash?: string;
}

/**
 * Документ
 */
export interface Document {
  /** Тип документа */
  type?: DocumentType;

  /** Поля документа */
  fields?: DocumentFields;
}

/**
 * Поля документа
 */
export type DocumentFields = AddFileSendingCcb;

/**
 * Валютный документ, к которому создан досыл
 */
export interface DocumentRef {
  /** Тип валютного документа */
  docType?: string;

  /** Номер валютного документа */
  docNumber?: string;

  /** Дата создания валютного документа */
  createDate?: string;
}

/**
 * Тип документа
 */
export interface DocumentType {
  /** Наименование документа */
  name?: string;

  /** Описание документа */
  desc?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface OrderCcbResponse {
  /** Документ ККБ */
  orderCcb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: Document;
}

/**
 * Причина отказа по договору
 */
export interface RejectCcb {
  /** Наименование причины отказа по договору */
  rejectReasonName?: string;

  /** Комментарий к причине отказа */
  comment?: string;
}

/**
 * Тип подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial?: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer?: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId?: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId?: string;
}

/**
 * Получение деталей документа
 */
export interface AddFileSendingDetailResponse {
  /**
   * Внешний идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Номер документа */
  documentNumber?: string;

  /** Статус документа */
  state?: string;

  /**
   * Дата создания документа
   * @format date
   */
  createDate?: string;

  /**
   * Дата и время последнего изменения записи
   * @format date-time
   */
  lastUpdate?: string;

  /**
   * Идентификатор отзыва документа
   * @format uuid
   */
  revokeId?: string;

  /** Вложения к документу */
  attachments?: AttachmentResponse[];

  /** Привилегии на документ */
  permissions?: PermissionResponse[];

  /**
   * Внешний идентификатор Клиента
   * @format uuid
   */
  clientId?: string;

  /** Тип исходного документа ВК, в рамках которого создан досыл */
  documentRefType?: string;

  /**
   * Идентификатор исходного документа ВК, в рамках которого создан досыл
   * @format uuid
   */
  documentRefId?: string;

  /** Список идентификаторов валютных договоров от исходного документа */
  documentRefContractIds?: string[];
}

/**
 * Информация о вложении
 */
export interface AttachmentResponse {
  /** Имя файла */
  fileName?: string;

  /** Размер файла */
  size?: string;

  /**
   * Дата заливки файла
   * @format date-time
   */
  createDate?: string;

  /** Хеш-сумма файла */
  hash?: string;

  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор файла
   * @format uuid
   */
  extId?: string;

  /** Состояние сохранения файла */
  ready?: boolean;

  /** Код ошибки сохранения файла */
  errorCode?: string;

  /** Описание ошибки при сохранении файла */
  errorDescription?: string;

  /** Категория файла */
  category?: string;
}

/**
 * Получение списка досылов
 */
export interface AddFileSendingListResponse {
  /**
   * Внешний идентификатор Клиента
   * @format uuid
   */
  clientId?: string;

  /** Тип исходного документа ВК, в рамках которого создан досыл */
  documentRefType?: string;

  /**
   * Идентификатор исходного документа ВК, в рамках которого создан досыл
   * @format uuid
   */
  documentRefId?: string;

  /**
   * Количество досылов
   * @format int32
   */
  statementAmount?: number;

  /** Список досылов */
  statements?: AddFileSendingResponse[];
}

/**
 * Получение деталей документа
 */
export interface AddFileSendingResponse {
  /**
   * Внешний идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Номер документа */
  documentNumber?: string;

  /** Статус документа */
  state?: string;

  /**
   * Дата создания документа
   * @format date
   */
  createDate?: string;

  /**
   * Дата и время последнего изменения записи
   * @format date-time
   */
  lastUpdate?: string;

  /**
   * Идентификатор отзыва документа
   * @format uuid
   */
  revokeId?: string;

  /** Вложения к документу */
  attachments?: AttachmentResponse[];

  /** Привилегии на документ */
  permissions?: PermissionResponse[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-ved-add-attachments
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://127.0.0.1:8080
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Досыл
     * @name GetAddFileSending
     * @summary Получение детальной информации
     * @request GET:/api/ved-add-attachments/v1/external/addfilesending/{id}
     * @secure
     */
    getAddFileSending: (id: string, params: RequestParams = {}) =>
      this.request<AddFileSendingDetailResponse, GenericError>({
        path: `/api/ved-add-attachments/v1/external/addfilesending/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Досыл
     * @name UpdateAddFileSending
     * @summary Редактирование
     * @request PUT:/api/ved-add-attachments/v1/external/addfilesending/{id}
     * @secure
     */
    updateAddFileSending: (
      id: string,
      data: AddFileSendingUpdateRequest,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/ved-add-attachments/v1/external/addfilesending/${id}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Досыл
     * @name DeleteAddFileSending
     * @summary Удаление
     * @request DELETE:/api/ved-add-attachments/v1/external/addfilesending/{id}
     * @secure
     */
    deleteAddFileSending: (id: string, params: RequestParams = {}) =>
      this.request<void, GenericError>({
        path: `/api/ved-add-attachments/v1/external/addfilesending/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name UploadMultipartFile
     * @summary Загрузка файла Клиентом
     * @request POST:/api/ved-add-attachments/v2/external/files/upload
     * @secure
     */
    uploadMultipartFile: (
      data: { file: File },
      query?: { category?: string },
      params: RequestParams = {}
    ) =>
      this.request<AttachmentUploadResponse, GenericError | void>({
        path: `/api/ved-add-attachments/v2/external/files/upload`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Смена статуса и отправка
     * @name UpdateDocumentStatus
     * @summary Обновление статуса документа
     * @request POST:/api/ved-add-attachments/v1/external/update-status/{documentType}/{id}
     * @secure
     */
    updateDocumentStatus: (
      documentType: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<void, GenericError>({
        path: `/api/ved-add-attachments/v1/external/update-status/${documentType}/${id}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Смена статуса и отправка
     * @name SendDocument
     * @summary Отправка подписанного документа в Банк
     * @request POST:/api/ved-add-attachments/v1/external/send/{documentType}/{id}
     * @secure
     */
    sendDocument: (
      documentType: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSendResponse, GenericError>({
        path: `/api/ved-add-attachments/v1/external/send/${documentType}/${id}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name Upload
     * @summary Загрузка файла Клиентом
     * @request POST:/api/ved-add-attachments/v1/external/files/upload
     * @secure
     */
    upload: (data: AttachmentRequest, params: RequestParams = {}) =>
      this.request<AttachmentUploadResponse, GenericError | void>({
        path: `/api/ved-add-attachments/v1/external/files/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Досыл
     * @name GetListAddFileSending
     * @summary Получение списка
     * @request GET:/api/ved-add-attachments/v1/external/addfilesending/{documentRefType}/{documentRefId}
     * @secure
     */
    getListAddFileSending: (
      documentRefType: string,
      documentRefId: string,
      params: RequestParams = {}
    ) =>
      this.request<AddFileSendingListResponse, GenericError>({
        path: `/api/ved-add-attachments/v1/external/addfilesending/${documentRefType}/${documentRefId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Досыл
     * @name CreateAddFileSending
     * @summary Создание
     * @request POST:/api/ved-add-attachments/v1/external/addfilesending/{documentRefType}/{documentRefId}
     * @secure
     */
    createAddFileSending: (
      documentRefType: string,
      documentRefId: string,
      data: AddFileSendingCreateRequest,
      query?: { isDraft?: boolean; skipWarnings?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/ved-add-attachments/v1/external/addfilesending/${documentRefType}/${documentRefId}`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение разрешений
     * @name GetPermissions
     * @summary Получение разрешений на документ
     * @request GET:/api/ved-add-attachments/v1/external/permissions/{documentType}
     * @secure
     */
    getPermissions: (documentType: string, params: RequestParams = {}) =>
      this.request<PermissionListResponse, GenericError>({
        path: `/api/ved-add-attachments/v1/external/permissions/${documentType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetOrderCcb
     * @summary Получение ККБ документа
     * @request GET:/api/ved-add-attachments/v1/external/confirmation/order-ccb/{documentType}/{documentId}
     * @secure
     */
    getOrderCcb: (
      documentId: string,
      documentType: string,
      params: RequestParams = {}
    ) =>
      this.request<OrderCcbResponse, GenericError>({
        path: `/api/ved-add-attachments/v1/external/confirmation/order-ccb/${documentType}/${documentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/ved-add-attachments/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, GenericError>({
        path: `/api/ved-add-attachments/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс управления сертификатами
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/ved-add-attachments/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, GenericError>({
        path: `/api/ved-add-attachments/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
